module.exports = __webpack_public_path__ + "img/Streeme-logo_big.60e699.png";